import Blacklist from '@/views/Blacklist'
import Blacklists from '@/views/Blacklists'
import Detail from '@/views/Detail'
import Details from '@/views/Details'
import Group from '@/views/Group'
import Groups from '@/views/Groups'
import Module from '@/views/Module'
import Modules from '@/views/Modules'
import Notifications from '@/views/Notifications'
import Notificationsettings from '@/views/Notificationsettings'
import Parts from '@/views/Parts'
import Parttype from '@/views/Parttype'
import Parttypes from '@/views/Parttypes'
import Producer from '@/views/Producer'
import Producers from '@/views/Producers'
import Profile from '@/views/Profile'
import Recover from '@/views/Recover'
import Register from '@/views/Register'
import Reportconsolidated from '@/views/Reportconsolidated'
import Reportorders from '@/views/Reportorders'
import Reportparts from '@/views/Reportparts'
import Reportsuppliers from '@/views/Reportsuppliers'
import Reset from '@/views/Reset'
import Router from 'vue-router'
import Supplier from '@/views/Supplier'
import Supplieruser from '@/views/Supplieruser'
import Supplierusers from '@/views/Supplierusers'
import Suppliers from '@/views/Suppliers'
import SupplierInfo from '@/views/SupplierInfo';
import Tender from '@/views/Tender'
import Tenders from '@/views/Tenders'
import TenderExport from '@/views/TenderExport'
import TenderHistory from '@/views/TenderHistory'
import TenderView from '@/views/TenderView'
import Vue from 'vue'
import Warehouse from '@/views/Warehouse'
import Warehouses from '@/views/Warehouses'
import Worker from '@/views/Worker'
import Workers from '@/views/Workers'
import ProductCategories from '@/views/ProductCategories';
import ProductCategoryEdit from '@/views/ProductCategoryEdit';
import ProductCategoriesList from '@/views/ProductCategoriesList';
import store from '../store'
import Units from "../views/Units";


Vue.use(Router)

const router = new Router({
	mode: 'history',
	hash: false,

	routes: [
		{
			path: '/setup/blacklists',
			name: 'blacklists',
			component: Blacklists
		},
		{
			path: '/setup/blacklists/add',
			name: 'blacklist_add',
			component: Blacklist
		},
		{
			path: '/setup/categories',
			name: 'admin_product_cat',
			component: ProductCategories
		},
		{
			path: '/reports/categories',
			name: 'admin_product_cat_report',
			component: ProductCategoriesList
		},
		{
			path: '/admin/product/categories/add',
			name: 'admin_product_cat_add',
			component: ProductCategoryEdit
		},
		{
			path: '/admin/product/categories/:cat_id/edit',
			name: 'admin_product_cat_edit',
			component: ProductCategoryEdit
		},
		{
			path: '/setup/blacklists/:id/edit',
			name: 'blacklist_edit',
			component: Blacklist
		},
		{
			path: '/setup/groups',
			name: 'groups',
			component: Groups
		},
		{
			path: '/setup/groups/add',
			name: 'group_add',
			component: Group
		},
		{
			path: '/setup/groups/:id/edit',
			name: 'group_edit',
			component: Group
		},
		{
			path: '/notifications',
			name: 'notifications',
			component: Notifications
		},
		{
			path: '/notifications/settings',
			name: 'notification_settings',
			component: Notificationsettings
		},
		{
			path: '/modules',
			name: 'modules',
			component: Modules
		},
		{
			path: '/setup/modules/add',
			name: 'module_add',
			component: Module
		},
		{
			path: '/setup/modules/:id/edit',
			name: 'module_edit',
			component: Module
		},
		{
			path: '/setup/parts',
			name: 'parts',
			component: Parts
		},
		{
			path: '/setup/parttypes',
			name: 'parttypes',
			component: Parttypes
		},
		{
			path: '/setup/parttypes/:id/edit',
			name: 'parttype_edit',
			component: Parttype
		},
		{
			path: '/details',
			name: 'details',
			component: Details
		},
		{
			path: '/details/:id/edit',
			name: 'detail_edit',
			component: Detail
		},
		{
			path: '/setup/producers',
			name: 'producers',
			component: Producers
		},
		{
			path: '/setup/producers/add',
			name: 'producer_add',
			component: Producer
		},
		{
			path: '/setup/producers/:id/edit',
			name: 'producer_edit',
			component: Producer
		},
		{
			path: '/setup/units',
			name: 'units',
			component: Units
		},
		{
			path: '/profile',
			name: 'profile',
			component: Profile
		},
		{
			path: '/recover',
			name: 'recover',
			component: Recover
		},
		{
			path: '/register',
			name: 'register',
			component: Register
		},
		{
			path: '/reports/consolidated',
			name: 'report_consolidated',
			component: Reportconsolidated
		},
		{
			path: '/reports/orders',
			name: 'report_orders',
			component: Reportorders,
			props: true
		},
		{
			path: '/reports/parts',
			name: 'report_parts',
			component: Reportparts
		},
		{
			path: '/reports/suppliers',
			name: 'report_suppliers',
			component: Reportsuppliers
		},
		{
			path: '/reset',
			name: 'reset',
			component: Reset
		},
		{
			path: '/suppliers',
			name: 'suppliers',
			component: Suppliers
		},
		{
			path: '/supplier/:sup_id/details',
			name: 'supplier_detail',
			component: SupplierInfo
		},
		{
			path: '/suppliers/add',
			name: 'supplier_add',
			component: Supplier
		},
		{
			path: '/suppliers/:id/edit',
			name: 'supplier_edit',
			component: Supplier
		},
		{
			path: '/supplier/:sup_id/users/add',
			name: 'supplier_users_add',
			component: Supplieruser
		},
		{
			path: '/supplier/:sup_id/users/edit',
			name: 'supplier_users_edit',
			component: Supplieruser
		},
		{
			path: '/supplier/:sup_id/users',
			name: 'supplier_users',
			component: Supplierusers
		},
		{
			path: '/tenders',
			name: 'tenders',
			component: Tenders
		},
		{
			path: '/tenders/add',
			name: 'tender_add',
			component: Tender
		},
		{
			path: '/tenders/:id/edit',
			name: 'tender_edit',
			component: Tender
		},
		{
			path: '/tenders/:id/export',
			name: 'tender_export',
			component: TenderExport
		},
		{
			path: '/tenders/:id/history',
			name: 'tender_history',
			component: TenderHistory
		},
		{
			path: '/tenders/:id/view',
			name: 'tender_view',
			component: TenderView
		},
		{
			path: '/setup/warehouses',
			name: 'warehouses',
			component: Warehouses
		},
		{
			path: '/setup/warehouses/:id/edit',
			name: 'warehouse_edit',
			component: Warehouse
		},
		{
			path: '/workers',
			name: 'workers',
			component: Workers
		},
		{
			path: '/workers/add',
			name: 'worker_add',
			component: Worker
		},
		{
			path: '/workers/:id/edit',
			name: 'worker_edit',
			component: Worker
		}
	]
})

router.beforeResolve((to, from, next) => {
	if (!store.getters.is_logged_in) {
		let route = window.location.pathname || '/tenders'
		sessionStorage.setItem('previous_route', route)
	}
	if (store.getters.is_logged_in && to.path === '/') {
		next('/tenders')
	}
	next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js